module.exports = __webpack_public_path__ + "media/images/pc/accessories/dress/dress_01-d58ebf71d5762f502fd1ca5a10ec5dda.jpg";